export default __webpack_public_path__ + "static/media/cPanelLogo.2486b3a0.png";